const mimeTypes = { 
  CSV_PLAIN: 'text/csv',
  CSV: 'application/vnd.ms-excel', 
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 
  TXT:'text/plain',
};

export default mimeTypes;



